// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__mDFwh","info":"Panel_info__qv2JH","note":"Panel_note__6vwWv","close":"Panel_close__f2Glp","btns":"Panel_btns__U0Aid","button":"Panel_button__5Msx6"};